import { ConfirmationDialogProps } from '../../design-system/components/molecules/ConfirmationDialog'
import { FrameworkService } from '../../services/framework-service'
import { InternalApiClient } from '../../services/internal-api-client'
import { errorToast } from '../../utils/error-toast'
import { successToast } from '../../utils/success-toast'
import { trackSecondaryNavButtonClick } from './tracker'
import { TTeam } from 'src/design-system'

export class TeamsSecondaryNavVm {
  private service: FrameworkService

  constructor(public team: TTeam, private client: InternalApiClient) {
    this.service = new FrameworkService(client)
  }

  get positionsPath() {
    return `/teams/${this.team.slug}`
  }

  get frameworksTemplatesPath() {
    return `/teams/${this.team.slug}/frameworks_templates`
  }

  get skillsPath() {
    return `/teams/${this.team.slug}/skills`
  }

  get frameworkPath() {
    return `/teams/${this.team.slug}/framework`
  }

  get peoplePath() {
    return `/teams/${this.team.slug}/memberships`
  }

  get readmePath() {
    return `/teams/${this.team.slug}/readme`
  }

  get openRolesPath() {
    return `/teams/${this.team.slug}/open_roles`
  }

  get settingsPath() {
    return `/teams/${this.team.slug}/edit`
  }

  publishFrameworkConfirmationProps = {
    title: 'Are you sure you want to publish this team?',
    body: 'This will make the team visible to everyone in your organization.',
    confirmLabel: 'Publish team',
  } satisfies ConfirmationDialogProps

  async onPublishTeamClick(frameworkId: number) {
    try {
      const result = await this.service.changeState({
        frameworkId,
        state: 'published',
      })
      successToast(result.notice)
      trackSecondaryNavButtonClick({
        button: 'Publish team',
        path: location.pathname,
      })
      return true
    } catch (e) {
      console.error(e)
      errorToast((e as Error).message)
      return false
    }
  }
}
